import { render, staticRenderFns } from "./BaseDepositButton.vue?vue&type=template&id=2198c37e&scoped=true"
import script from "./BaseDepositButton.vue?vue&type=script&lang=js"
export * from "./BaseDepositButton.vue?vue&type=script&lang=js"
import style0 from "./BaseDepositButton.vue?vue&type=style&index=0&id=2198c37e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2198c37e",
  null
  
)

export default component.exports